import Loadable from 'my-components/Loadable';

export default Loadable(() => import(/* webpackChunkName: "mcat-scores-hub" */ './MCATScoresHub'));
